export default "__VITE_ASSET__hBRFSr8u__"